import { render, staticRenderFns } from "./Screening1.vue?vue&type=template&id=e5a080f2&"
import script from "./Screening1.vue?vue&type=script&lang=js&"
export * from "./Screening1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports